import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { EditProfileAPI } from '../api/myaccount/editprofile/editprofileapi';
import { EditProfileRequest } from '../api/myaccount/editprofile/editprofilerequest';
import { EditProfileResponse } from '../api/myaccount/editprofile/editprofileresponse';
import { GetProfileDetailsAPI } from '../api/myaccount/getprofiledetails/getprofiledetailsapi';
import { GetProfileDetailsRequest } from '../api/myaccount/getprofiledetails/getprofiledetailsrequest';
import { GetProfileDetailsResponse } from '../api/myaccount/getprofiledetails/getprofiledetailsresponse';
import { LogoutAPI } from '../api/myaccount/logout/logoutapi';
import { LogoutRequest } from '../api/myaccount/logout/logoutrequest';
import { LogoutResponse } from '../api/myaccount/logout/logoutresponse';
import { TransactionHistoryAPI } from '../api/myaccount/transactionhistory/transactionhistoryapi';
import { TransactionHistoryRequest } from '../api/myaccount/transactionhistory/transactionhistoryrequest';
import { TransactionHistoryResponse } from '../api/myaccount/transactionhistory/transactionhistoryresponse';
import { PackStatusAPI } from '../api/packstatus/packstatusapi';
import { PackStatusRequest } from '../api/packstatus/packstatusrequest';
import { PackStatusResponse } from '../api/packstatus/packstatusresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { EditProfileAPIProcessorImpl } from '../processor/editprofileapiprocessor';
import { GetProfileDetailsAPIProcessorImpl } from '../processor/getprofiledetailsapiprocessor';
import { LogoutAPIProcessorImpl } from '../processor/logoutapiprocessor';
import { PackStatusAPIProcessorImpl } from '../processor/packstatusapiprocessor';
import { TransactionHistoryAPIProcessorImpl } from '../processor/transactionhistoryapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';

export class MyAccountProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(MyAccountProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getEditProfileAPIProcessor():APIProcessor<EditProfileRequest, EditProfileResponse>
    {
        this.logger.log("getEditProfileAPIProcessor() invoked");
        return new EditProfileAPIProcessorImpl(this.getContext(), new EditProfileAPI(this.getHttpClient(), this.getContext()));
    }

    getGetProfileDetailsAPIProcessor():APIProcessor<GetProfileDetailsRequest, GetProfileDetailsResponse>
    {
        this.logger.log("getGetProfileDetailsAPIProcessor() invoked");
        return new GetProfileDetailsAPIProcessorImpl(this.getContext(), new GetProfileDetailsAPI(this.getHttpClient(), this.getContext()));
    }

    getPackStatus():APIProcessor<PackStatusRequest, PackStatusResponse>
    {
        this.logger.log("getPackStatus() invoked");
        return new PackStatusAPIProcessorImpl(this.getContext(), new PackStatusAPI(this.getHttpClient(), this.getContext()));
    }

    getTransactionHistoryDetails():APIProcessor<TransactionHistoryRequest, TransactionHistoryResponse>
    {
        this.logger.log("getTransactionHistoryDetails() invoked");
        return new TransactionHistoryAPIProcessorImpl(this.getContext(), new TransactionHistoryAPI(this.getHttpClient(), this.getContext()));
    }

    getLogoutDetails():APIProcessor<LogoutRequest, LogoutResponse>
    {
        this.logger.log("getLogoutDetails() invoked");
        return new LogoutAPIProcessorImpl(this.getContext(), new LogoutAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/myaccountprocessorfactory.tsx